import pimg1 from '../images/project/1.jpg'
import pimg2 from '../images/project/2.jpg'
import pimg3 from '../images/project/3.jpg'
import pimg4 from '../images/project/4.jpg'
import pimg5 from '../images/project/5.jpg'
import pimg6 from '../images/project/6.jpg'
import pimg7 from '../images/project/7.jpg'
import pimg8 from '../images/project/8.jpg'
import pimg9 from '../images/project/p1.jpg'
import pimg10 from '../images/project/p2.jpg'
import pimg11 from '../images/project/p3.jpg'
import pimg12 from '../images/project/p4.jpg'
import pimg13 from '../images/project/p5.jpg'
import pimg14 from '../images/project/p6.jpg'
import pimg15 from '../images/project/p7.jpg'
import pimg16 from '../images/project/p8.jpg'




const Projects = [
    {
        id: '1',
        title: 'Redefining E-commerce',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'KUALA LUMPUR, MALAYSIA',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose',
        pimg1: pimg1,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '2',
        title: 'Design That Converts',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'KUALA LUMPUR, MALAYSIA',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose2',
        pimg1: pimg2,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '3',
        title: 'A New Brand Identity',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'KUALA LUMPUR, MALAYSIA',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose3',
        pimg1: pimg3,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '4',
        title: 'Business card design',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'KUALA LUMPUR, MALAYSIA',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose4',
        pimg1: pimg4,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '5',
        title: 'Website development',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'Web Design & Dev',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose5',
        pimg1: pimg5,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '6',
        title: 'A New Brand Identity',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'Web Design & Dev',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose6',
        pimg1: pimg6,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '7',
        title: 'Web Savvy Solutions',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'Web Design & Dev',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose7',
        pimg1: pimg7,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '8',
        title: 'Business card design',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'Web Design & Dev',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose8',
        pimg1: pimg8,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '9',
        title: 'Business card design',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'Web Design & Dev',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose9',
        pimg1: pimg9,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '10',
        title: 'Business card design',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'Web Design & Dev',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose10',
        pimg1: pimg10,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '11',
        title: 'Business card design',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'Web Design & Dev',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose11',
        pimg1: pimg11,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '12',
        title: 'Business card design',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'Web Design & Dev',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose12',
        pimg1: pimg12,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '13',
        title: 'Business card design',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'Web Design & Dev',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose13',
        pimg1: pimg13,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '14',
        title: 'Business card design',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'Web Design & Dev',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose14',
        pimg1: pimg14,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '15',
        title: 'Business card design',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'Web Design & Dev',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose15',
        pimg1: pimg15,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '16',
        title: 'Business card design',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'Web Design & Dev',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose16',
        pimg1: pimg16,
        date: 'Feb 2024',
        location: 'Austria',
    },
    {
        id: '17',
        title: 'Business card design',
        title2: 'Commercial',
        title3: 'Architecture',
        subtitle: 'Web Design & Dev',
        subtitle2: 'Architecture Design',
        slug: 'Jack-Rose17',
        pimg1: pimg14,
        date: 'Feb 2024',
        location: 'Austria',
    },




]
export default Projects;






